<template>
  <div class="modal fade slide-up" id="candidate-addon-popup" tabindex="-1" role="dialog" aria-hidden="false" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content-wrapper">
        <div class="modal-content">
          <div class="modal-header">
            <label class="addon-title" v-if="isManager">{{ $t('UserForm.addon_manager_title') }}</label>
            <label class="addon-title" v-else>{{ $t('UserForm.addon_title') }}</label>
          </div>

          <div class="modal-body" :key="componentKey">
            <template v-for="(entity, index) in entities">
              <div class="checkbox" :key="'checkbox_' + index + componentKey">
                <input
                  v-if="entity.existence"
                  type="checkbox"
                  :id="'entity_' + entity.id"
                  disabled
                  checked
                />
                <input
                  v-else
                  type="checkbox"
                  :id="'entity_' + entity.id"
                  v-model="entity.selected"
                  @change="selectEntity(entity, index)"
                />
                <label :for="'entity_' + entity.id">{{ entity.name }}</label>

                <div
                  v-if="entity.existence"
                  :key="'notification_' + index">
                  {{ $t('UserForm.candidate_attached_to_entity') }}
                </div>
              </div>

              <candidate-addon-info
                v-if="entity.selected"
                :key="'addon_' + index + componentKey"
                :entityId="entity.id"
                :addOn="addOns[index]"
                :index="index"
                :occupations="occupations"
                :checkValid="checkValid"
                :isManager="isManager"
                :entity="entity"
                @onCheckValidChange="onCheckValidChange"
              />
            </template>
          </div>

          <div class="modal-footer d-flex justify-content-between">
            <button
              type="button"
              class="btn btn-default btn-cons"
              @click="closeCandidateAddonPopup">
              {{ $t("UserForm.cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary btn-cons"
              @click="updateCandidateAddon">
              {{ $t("UserForm.submit") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CandidateAddonInfo from './CandidateAddonInfo'
  import { getSiblingsOfEntity } from '@/backend/entities'
  import { mapGetters, mapState } from 'vuex'
  import { checkValidEmail } from '@/helpers/email'

  export default {
    name: 'CandidateAddonPopup',
    components: {
      CandidateAddonInfo
    },
    props: [
      'entityId',
      'occupations',
      'email',
      'isManager'
    ],
    data() {
      return {
        entities: [],
        componentKey: 0,
        validArray: [],
        tempAddons: [],
        selectedEntityCount: 0,
        checkValid: false
      }
    },
    computed: {
      ...mapGetters({
        addOns: 'users/addOns',
        addOnPopupKey: 'users/addOnPopupKey',
      })
    },
    methods: {
      closeCandidateAddonPopup() {
        $('#candidate-addon-popup').modal('hide')
      },
      selectEntity(entity, index) {
        if (entity.selected) {
          this.selectedEntityCount += 1
        } else {
          const addon = { ... this.addOns[index], selected: false }
          this.tempAddons.push(addon)
          this.selectedEntityCount -= 1
        }
      },
      initAddOns(entities) {
        const addOn = {
          entity_id: null,
          resource_type: 'extern',
          affiliated_service: null,
          services: [],
          occupations: [],
          unavailability_dates_provider_id: null,
          selected: false
        }
        return entities.map((entity, index) => { return { ...addOn, index, entity_id: entity.id } })
      },
      updateCandidateAddon() {
        this.checkValid = true
        if (this.selectedEntityCount == 0) {
          this.$store.commit('users/SET_ADDONS', this.initAddOns(this.entities))
          this.checkValid = false
          $('#candidate-addon-popup').modal('hide')
        }
      },
      onCheckValidChange(value, addOn) {
        this.validArray.push(value)
        if (value) {
          this.tempAddons.push(addOn)
        }
        this.checkValid = false
      }
    },
    mounted() {
      if (this.email == '' || checkValidEmail(this.email)) {
        getSiblingsOfEntity(this.entityId, this.email).then(response => {
          const entities = response.data
          this.entities = entities.map(entity => { return { ...entity, selected: false } })

          this.$store.commit('users/SET_SIBLING_ENTITIES', entities)
          this.$store.commit('users/SET_ADDONS', this.initAddOns(entities))
        })
      }
    },
    watch: {
      email() {
        if (checkValidEmail(this.email)) {
          this.$store.commit('users/SET_ADDON_POPUP_KEY')
        }
      },
      validArray() {
        if (this.validArray.length == 0) return

        if (this.validArray.length == this.selectedEntityCount && !this.validArray.includes(false)) {
          const addons = [...this.addOns]
          this.tempAddons.forEach(temp => {
            addons[temp.index]  = { ...temp }
          })
          this.$store.commit('users/SET_ADDONS', addons)
          $('#candidate-addon-popup').modal('hide')
        }
        this.validArray = []
        this.tempAddons = []
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modal-header {
    padding: 16px 16px 0 16px;
  }
  .modal-body {
    padding: 16px 16px 0 16px;
  }
  .modal-footer {
    padding: 16px 0;
    margin: 0 16px;
    border-top: 1px solid rgba(#000000, 0.3);
  }
  .addon-title {
    color: #e51349;
    margin-bottom: 0;
  }
  .btn-cons {
    margin-right: 0;
  }
  .checkbox {
    margin: 0 0 16px 0;
    input[type=checkbox]:checked + label:before {
      border-color: #e51349;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/users/CandidateAddonPopup.vue